<template>
    <div id="student-triage" class="container my-5 pb-5">
        <div class="card">
            <div class="card-body">
                <h5 class="card-title"><i class="fas fa-file-alt"></i> Academic Counselling Questionaire</h5>
                <student-triage-form :capacityMet="capacityMet" :counsellorsData="counsellorsData" :triageSettings="triageSettings" :user="user"
                    @refreshData="refreshData" @setState="setState" @setTriageData="setTriageData"
                    @setTriageSubmit="setTriageSubmit">
                </student-triage-form>
            </div>
        </div>
    </div>
</template>

<script>
import StudentTriageForm from '../../components/Student/Triage/Form.vue';

export default {
    name: 'student-triage',
    components: {
        StudentTriageForm
    },
    props: {
        capacityMet: {
            required: true
        },
        counsellorsData: {
            type: Array
        },
        triageSettings: {
            type: Object
        },
        user: {
            type: Object
        }
    },
    methods: {
        refreshData() {
            this.$emit('refreshData');
        },
        setState(state) {
            this.$emit('setState', state);
        },
        setTriageData(data) {
            this.$emit('setTriageData', data);
        },
        setTriageSubmit(bool) {
            this.$emit('setTriageSubmit', bool);
        }
    }
}
</script>